import React, { useEffect, useState } from 'react';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import HowItWorks from './components/HowItWorks';
import ResearchSection from './components/ResearchSection';
import Testimonials from './components/Testimonials';
import Quiz from './components/Quiz/Quiz';
import Results from './components/Results/Results';
import ProductSection from './components/ProductSection';
import JoinOthers from './components/JoinOthers';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import MetaPixel from './components/MetaPixel';
export function App() {
  const [quizStarted, setQuizStarted] = useState(false);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [quizResults, setQuizResults] = useState(null);
  useEffect(() => {
    // Set the page title
    document.title = 'Sexuell Hälsa & Prestationsförmåga Quiz';
  }, []);
  const startQuiz = () => {
    setQuizStarted(true);
    window.scrollTo(0, 0);
  };
  const completeQuiz = results => {
    setQuizResults(results);
    setQuizCompleted(true);
    setQuizStarted(false);
    window.scrollTo(0, 0);
  };
  return <div className="min-h-screen bg-[#0A1020] text-white font-sans" data-id="element-0">
      {/* Meta Pixel tracking component */}
      <MetaPixel data-id="element-1" />
      {!quizStarted && !quizCompleted && <>
          <Hero onStartQuiz={startQuiz} data-id="element-2" />
          <TrustStrip data-id="element-3" />
          <HowItWorks data-id="element-4" />
          <ResearchSection data-id="element-5" />
        </>}
      {quizStarted && <Quiz onComplete={completeQuiz} data-id="element-6" />}
      {quizCompleted && <>
          <Results profile={quizResults} data-id="element-7" />
          <ProductSection profile={quizResults} data-id="element-8" />
          <JoinOthers data-id="element-9" />
          <Testimonials data-id="element-10" />
          <FAQ data-id="element-11" />
        </>}
      <Footer data-id="element-12" />
    </div>;
}